<template>
  <div class="board-detail-status">
    <device-component-list-modem ref="list" :modemSn="modemSn"></device-component-list-modem>
  </div>
</template>

<script>
import deviceComponentListModem from '@/components/deviceComponentListModem.vue';

export default {
  props: {
    modemSn: String
  },
  components: {
    deviceComponentListModem
  },
  data() {
    return {
    };
  },
  methods: {
    udpate() {
      this.$refs.list.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.board-detail-status {
  padding: 0 24px 44px 24px;
}
</style>
